<div class="row justify-content-center">
    <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12 mat-elevation-z8">
        <div class="row heading mat-elevation-z8">
            <div class="col-12">
                <h1 class=" text-center  coolfont"><mat-icon style="font-size: 30px;">assignment</mat-icon> Selected Plan</h1>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <h5 class="text-center">{{plan.pname}}</h5>
                <h5 class="text-center">{{plan.category}}</h5>
                <h5 class="text-center">{{plan.speed}}</h5>
                <h5 class="text-center">Upto {{plan.data}}</h5>
                <h5 class="text-center">Post usage speed: {{plan.exspeed}}</h5>
                <h5 class="text-center">Rs. {{plan.price}}/Month</h5>
            </div>
        </div>
        <br>
    </div>
</div>
<div class="row justify-content-center">
    <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12 mt-3 text-center">
        <button mat-raised-button class="bluebtn inlineb" (click)='goCheckout()'>Place Order</button>
        <button mat-raised-button class="orangebtn ml-2 inlineb" (click)='goCancel()'>Cancel</button>
    </div>
</div>